// ============================================================
// ActivityViewModal.tsx
// The Activity DETAIL view — opened from a timeline entry (row / title
// click, or the eye icon) for everyone. VIEW-FIRST: Edit is a deliberate
// second step (this footer's Edit, or the feed's hover pencil).
//
// Redesigned to the approved mockup (outputs/casevo-activity-picker-and-
// view.html §4) on the shared ModalFrame — the same frame as the add-
// activity / email modals:
//   • hero band: type pill (+icon) · case ref · Billable · Unbilled WIP /
//     Billed pills · the action as title · who + when;
//   • a details card (With · Case · Logged), a Billing card (time · units ·
//     £ · grade/rate or status) and the note;
//   • footer: Delete (left) · Close · Edit (the one green primary).
// Rules (unchanged):
//   ★ GRADES ARE ADMIN-ONLY — grade + hourly rate render only for admins
//     (the API also strips them for non-admins: activityController forViewer).
//   ★ A colleague's £ withheld by the server (amountPence === null, "See
//     colleagues' billing") shows the lock + dash (WithheldAmount).
//   ★ Edit / Delete only when the caller says the viewer may (author or
//     admin) AND the entry isn't billed (the API 409s edits on billed rows).
//
// The content (hero pieces, cards, footer, re-price, file open) lives in
// ActivityViewContent.tsx (useActivityView) so CaseQuickViewModal's in-frame
// drill-in renders the SAME view; this file is just that content in the
// shared ModalFrame — same props as before.
// ============================================================
import React from 'react'
import ModalFrame from './ModalFrame'
import { useActivityView, type ActivityViewProps } from './ActivityViewContent'

const ActivityViewModal: React.FC<ActivityViewProps> = (props) => {
  const v = useActivityView(props)
  if (!v) return null

  return (
    <ModalFrame
      isOpen
      onClose={props.onClose}
      size="lg"
      eyebrow={v.eyebrow}
      eyebrowIcon={v.eyebrowIcon}
      pills={v.pills}
      title={v.title}
      subtitle={v.subtitle}
      initialFocusRef={v.closeRef}
      bodyClassName="flex flex-col gap-[14px]"
      footerLeft={v.footerLeft}
      footerRight={v.footerRight}
    >
      {v.body}
    </ModalFrame>
  )
}

export default ActivityViewModal
